"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetReliabilityDetailsWebModel = createGetReliabilityDetailsWebModel;
exports.defaultConfig = void 0;
exports.fetchGetReliabilityDetailsWeb = fetchGetReliabilityDetailsWeb;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

const defaultConfig = exports.defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'newbuilding-reliability',
  pathApi: '/v2/get-reliability-details-web/'
};
function createGetReliabilityDetailsWebModel(parameters) {
  return _objectSpread(_objectSpread({}, defaultConfig), {}, {
    parameters
  });
}
async function fetchGetReliabilityDetailsWeb(_ref) {
  let {
    httpApi,
    config,
    mappers,
    parameters
  } = _ref;
  const {
    statusCode,
    response,
    headers
  } = await httpApi.fetch(createGetReliabilityDetailsWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response);
    }
    if (statusCode === 400) {
      return mappers[400](response);
    }
  }
  return {
    statusCode,
    response,
    headers
  };
}